import styled from 'styled-components';

const StyledNameSufix = styled.span`
    @media screen and (max-width: 476px) {
        display: none;
    }
`;

export default StyledNameSufix;
